import { createFileRoute } from "@tanstack/react-router";

import { SignIn } from "@/views/login/sign-in";

export const Route = createFileRoute("/_guest/sign-in")({
  component: SignIn,
});
